import React from "react";

/** Asquera Practice — store listings */
export const PRACTICE_PLAY_STORE_URL =
    "https://play.google.com/store/apps/details?id=com.rovoid.asquera.practice";
export const PRACTICE_APP_STORE_URL =
    "https://apps.apple.com/eg/app/asquera-practice/id6757539057";

/**
 * Overlay CTA for the practice app. Keep outside `<vdocipher-player>` so it matches
 * your site and stays out of the player shadow DOM (recommended by VdoCipher).
 * @see https://www.vdocipher.com/docs/player/v2/examples/inject-html/
 */
export default function PracticeAppCta({ className }) {
    const linkStyle = {
        color: "#7eb8ff",
        fontWeight: 600,
        fontSize: 13,
        textDecoration: "underline",
        whiteSpace: "nowrap",
    };

    return (
        <div
            className={className}
            style={{
                position: "absolute",
                top: 12,
                left: 12,
                zIndex: 20,
                pointerEvents: "auto",
                maxWidth: "min(280px, calc(100% - 24px))",
            }}
            aria-label="Practice app download links"
        >
            <div
                style={{
                    background: "rgba(14, 31, 66, 0.92)",
                    color: "#fff",
                    borderRadius: 8,
                    padding: "10px 12px",
                    boxShadow: "0 4px 14px rgba(0,0,0,0.28)",
                }}
            >
                <span
                    style={{
                        fontWeight: 700,
                        fontSize: 14,
                        display: "block",
                        marginBottom: 8,
                        lineHeight: 1.3,
                    }}
                >
                    Try Practice Now
                </span>
                <div
                    style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "10px 14px",
                        alignItems: "center",
                    }}
                >
                    <a
                        href={PRACTICE_PLAY_STORE_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={linkStyle}
                    >
                        Google Play
                    </a>
                    <a
                        href={PRACTICE_APP_STORE_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={linkStyle}
                    >
                        App Store
                    </a>
                </div>
            </div>
        </div>
    );
}
